import { useFormatMessage } from "@comparaonline/react-intl-hooks";

import { useAppContext } from "../../../../../../lib/appContext";
import { getHostname } from "../../../../../../core/helpers";
import { BreadcrumbItem } from "../../types";

type UseBaseBreadcrumb = () => BreadcrumbItem[];
const useBaseBreadcrumb: UseBaseBreadcrumb = () => {
  const formatMessage = useFormatMessage();
  const {
    businessUnitSlug,
    businessUnitConfig: { name },
    countryCode
  } = useAppContext();

  const homeUrl = getHostname(countryCode);

  const homePath = {
    url: homeUrl,
    text: formatMessage("breadcrumbs")
  };

  const businessUnitPath = {
    url: `${homeUrl}/${businessUnitSlug}`,
    text: name
  };

  return [homePath, businessUnitPath];
};

export { useBaseBreadcrumb };
